import type { RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/post', //?id=
    name: 'postIndex', //帖子详情
    meta: {
      title: '',
    },
    component: () => import('@/views/post/index.vue'),
  },
  {
    path: '/post/video', //?id=
    name: 'videoPost',
    meta: {
      title: '长城汽车', //视频帖子
    },
    component: () => import('@/views/post/video.vue'),
  },
  {
    path: '/test', //?id=
    name: 'test',
    meta: {
      title: '测试页面',
    },
    component: () => import('@/views/demo/index.vue'),
  },
  {
    path: '/travelScene', //?id=
    name: 'test',
    meta: {
      title: '浏览模式测试',
    },
    component: () => import('@/views/demo/travelScene.vue'),
  },
  {
    path: '/download',
    name: 'downloadAPP',
    meta: {
      title: '长城汽车APP下载',
    },
    component: () => import('@/views/downloadPage/index.vue'),
  },
  {
    path: '/dowmForRegist',
    name: 'dowmForRegist',
    meta: {
      title: '长城汽车APP下载', //为邀请注册页面提供
    },
    component: () => import('@/views/downloadPage/dowmForRegist.vue'),
  },
]

export default routes
